module.exports = __webpack_public_path__ + "static/media/splendor.2d38651e.jpg";